// Sends Content-Security-Policy violations to Dash0 through the logger, so a report-only policy
// shows what enforcing it would break without a separate report endpoint.

import { logger } from "@/lib/logger";

/**
 * Reduces a blocked or source URI to its origin, or to the keyword/scheme for "inline", "eval",
 * blob: and data:. Full URLs can carry presigned signatures or share tokens.
 */
export function describeCspUri(uri: string): string {
    if (/^[a-z-]+$/u.test(uri)) {
        return uri;
    }

    try {
        const url = new URL(uri);
        return url.protocol === "http:" || url.protocol === "https:" ? url.origin : url.protocol.slice(0, -1);
    } catch {
        return "other";
    }
}

export function reportContentSecurityPolicyViolations() {
    // One report per directive and origin per page load: a blocked resource can fire on every render.
    const reported = new Set<string>();

    document.addEventListener("securitypolicyviolation", (event) => {
        const blocked = describeCspUri(event.blockedURI);
        const key = `${event.effectiveDirective} ${blocked}`;

        if (reported.has(key)) {
            return;
        }

        reported.add(key);
        logger.warn("Content Security Policy violation", undefined, {
            "contentvault.csp.directive": event.effectiveDirective,
            "contentvault.csp.blocked": blocked,
            "contentvault.csp.disposition": event.disposition,
            "contentvault.csp.source": event.sourceFile ? describeCspUri(event.sourceFile) : undefined,
        });
    });
}
